/* ============================================================
   norsu Interiors — custom email signup popup
   Submits directly to Klaviyo's public client API so profiles
   land on the "norsu newsletter" list (u7kSLr) exactly as the
   Klaviyo-built form did — which is what fires the live
   "1. Welcome newsletter / automation" flow (Added to List).

   Config comes from the data-config JSON blob rendered by
   snippets/norsu-signup-popup.liquid.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('norsu-signup-popup');
  if (!root) return;

  var cfg;
  try {
    cfg = JSON.parse(root.getAttribute('data-config') || '{}');
  } catch (e) {
    return;
  }
  if (!cfg.companyId || !cfg.listId) return;

  var KEY_DISMISSED = 'norsu_popup_snooze_until';
  var KEY_JOINED = 'norsu_popup_joined';
  var KLAVIYO_REVISION = '2024-10-15';

  var teaser = document.getElementById('norsu-signup-teaser');

  // Reparent to <body>. The snippet renders inside the footer section, and a
  // transformed/filtered ancestor there would break position:fixed — plus it
  // takes the popup out of reach of any section-scoped footer CSS.
  if (root.parentNode !== document.body) document.body.appendChild(root);
  if (teaser && teaser.parentNode !== document.body) document.body.appendChild(teaser);

  var els = {
    scrim: root.querySelector('.nsp__scrim'),
    card: root.querySelector('.nsp__card'),
    close: root.querySelector('.nsp__close'),
    emailForm: root.querySelector('[data-nsp-form="email"]'),
    emailInput: root.querySelector('[data-nsp-input="email"]'),
    emailError: root.querySelector('[data-nsp-error="email"]'),
    emailSubmit: root.querySelector('[data-nsp-form="email"] .nsp__submit'),
    phoneForm: root.querySelector('[data-nsp-form="phone"]'),
    phoneInput: root.querySelector('[data-nsp-input="phone"]'),
    phoneError: root.querySelector('[data-nsp-error="phone"]'),
    phoneSubmit: root.querySelector('[data-nsp-form="phone"] .nsp__submit'),
    successEmail: root.querySelector('[data-nsp-success-email]'),
    copyBtn: root.querySelector('[data-nsp-copy]')
  };

  var state = { open: false, email: '', lastFocus: null, armed: false };
  var scrollLock = { y: 0, active: false };

  /* ---- scroll lock ----------------------------------------
     NOT `documentElement.style.overflow = 'hidden'`. This theme sets
     html/body to height:100% with the content overflowing, so hiding
     overflow on <html> clips the scrollable area and the page loses its
     scroll position — on mobile you land past the end of the (now short)
     document and see a blank white screen after closing. Pinning the body
     and restoring the exact offset is the safe equivalent.
     -------------------------------------------------------- */
  function lockScroll() {
    if (scrollLock.active) return;
    scrollLock.y = window.pageYOffset || document.documentElement.scrollTop || 0;
    scrollLock.active = true;
    var s = document.body.style;
    s.position = 'fixed';
    s.top = -scrollLock.y + 'px';
    s.left = '0';
    s.right = '0';
    s.width = '100%';
    s.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!scrollLock.active) return;
    scrollLock.active = false;
    var s = document.body.style;
    s.position = '';
    s.top = '';
    s.left = '';
    s.right = '';
    s.width = '';
    s.overflow = '';
    window.scrollTo(0, scrollLock.y);
  }

  /* ---- storage helpers (private mode safe) ---------------- */
  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* no-op */ }
  }
  function snooze(days) {
    write(KEY_DISMISSED, String(Date.now() + days * 86400000));
  }
  function isSnoozed() {
    var until = parseInt(read(KEY_DISMISSED) || '0', 10);
    return until > Date.now();
  }

  /* ---- suppression rules ---------------------------------- */

  // Klaviyo drops a __kla_id cookie holding a base64 JSON blob. Once it
  // carries an email the visitor is a known profile, so we stay quiet —
  // this mirrors the Klaviyo form's "don't show to existing profiles".
  function isKnownKlaviyoProfile() {
    var match = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!match) return false;
    try {
      var decoded = JSON.parse(atob(decodeURIComponent(match[1])));
      return !!(decoded && (decoded.$email || (decoded.$exchange_id && decoded.$email)));
    } catch (e) {
      return false;
    }
  }

  function isExcludedPath() {
    var path = window.location.pathname.toLowerCase();
    // Prefix match on a path boundary — a bare substring test would also
    // silence the popup on e.g. /products/cart-caddy.
    return (cfg.excludePaths || []).some(function (fragment) {
      return path === fragment || path.indexOf(fragment + '/') === 0;
    });
  }

  // Never stack on top of the cart drawer, nav drawer or a quickview.
  function otherOverlayOpen() {
    if (document.body.classList.contains('js-drawer-open')) return true;
    if (document.body.classList.contains('nv-drawer-open')) return true;
    var cart = document.getElementById('slideout-quickview-cart');
    if (cart && cart.classList.contains('is-open')) return true;
    var openDrawer = document.querySelector('.drawer.is-open, .modal--is-active');
    return !!openDrawer;
  }

  function shouldSkip() {
    if (cfg.suppress) return true;              // logged-in subscriber, theme editor, etc.
    if (read(KEY_JOINED) === '1') return true;
    if (isSnoozed()) return true;
    if (isExcludedPath()) return true;
    if (isKnownKlaviyoProfile()) return true;
    return false;
  }

  /* ---- open / close --------------------------------------- */
  function open(source) {
    if (state.open) return;
    state.open = true;
    preloadImage();
    state.lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nsp-modal-open');
    lockScroll();
    if (teaser) teaser.setAttribute('data-show', 'false');

    window.setTimeout(function () {
      if (els.emailInput && root.querySelector('[data-nsp-step="email"][data-active="true"]')) {
        els.emailInput.focus({ preventScroll: true });
      } else if (els.close) {
        els.close.focus({ preventScroll: true });
      }
    }, 420);

    track('norsu_popup_view', { trigger: source || 'auto' });
  }

  function close(reason) {
    if (!state.open) return;
    state.open = false;
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nsp-modal-open');
    unlockScroll();

    if (reason !== 'joined') {
      snooze(cfg.snoozeDays || 30);
      showTeaser();
    }
    if (state.lastFocus && state.lastFocus.focus) {
      state.lastFocus.focus({ preventScroll: true });
    }
  }

  function showTeaser() {
    if (!teaser || !cfg.showTeaser) return;
    window.setTimeout(function () { teaser.setAttribute('data-show', 'true'); }, 900);
  }

  function goToStep(name) {
    root.querySelectorAll('[data-nsp-step]').forEach(function (step) {
      step.setAttribute('data-active', step.getAttribute('data-nsp-step') === name ? 'true' : 'false');
    });
  }

  /* ---- analytics ------------------------------------------ */
  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* no-op */ }
    try {
      // gtag.js (G-7WY728W0V3) ignores the GTM-shaped push above, and no GTM
      // tag forwards it — send the GA4 event explicitly or it never arrives.
      if (typeof window.gtag === 'function') window.gtag('event', event, payload || {});
    } catch (e) { /* no-op */ }
    try {
      if (window.clarity) window.clarity('event', event);
    } catch (e) { /* no-op */ }
  }

  /* ---- Klaviyo ------------------------------------------- */
  function subscribe(profileAttributes) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.customSource || 'norsu site popup',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.listId } }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId),
      {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(body)
      }
    ).then(function (response) {
      // 202 Accepted with an empty body is the success case.
      if (response.status === 202 || response.ok) return true;
      return response.text().then(function (text) {
        throw new Error('Klaviyo ' + response.status + ': ' + text);
      });
    });
  }

  // Keep on-site tracking (viewed product, started checkout) attached to
  // the profile we just created.
  function identify(email) {
    try {
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', { $email: email }]);
      }
    } catch (e) { /* no-op */ }
  }

  /* ---- validation ----------------------------------------- */
  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
  }

  // AU mobile: 04xx xxx xxx / 4xx xxx xxx / +614xx xxx xxx
  function normaliseAuPhone(value) {
    var digits = value.replace(/[^\d]/g, '');
    if (digits.indexOf('61') === 0) digits = digits.slice(2);
    if (digits.indexOf('0') === 0) digits = digits.slice(1);
    if (!/^4\d{8}$/.test(digits)) return null;
    return '+61' + digits;
  }

  function setError(field, message) {
    var errorEl = field === 'email' ? els.emailError : els.phoneError;
    var inputEl = field === 'email' ? els.emailInput : els.phoneInput;
    if (errorEl) {
      errorEl.textContent = message || '';
      errorEl.setAttribute('data-show', message ? 'true' : 'false');
    }
    if (inputEl) inputEl.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.setAttribute('data-loading', loading ? 'true' : 'false');
    button.disabled = !!loading;
  }

  /* ---- submit handlers ------------------------------------ */
  if (els.emailForm) {
    els.emailForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (els.emailInput.value || '').trim();

      if (!validEmail(email)) {
        setError('email', 'Please enter a valid email address.');
        els.emailInput.focus();
        return;
      }
      setError('email', '');
      setLoading(els.emailSubmit, true);

      subscribe({
        email: email,
        properties: {
          signup_source: cfg.customSource || 'norsu site popup',
          signup_page: window.location.pathname
        }
      })
        .then(function () {
          state.email = email;
          write(KEY_JOINED, '1');
          identify(email);
          track('norsu_popup_submit', { method: 'email' });
          if (els.successEmail) els.successEmail.textContent = email;
          goToStep(cfg.askForPhone ? 'phone' : 'success');
          if (cfg.askForPhone && els.phoneInput) {
            window.setTimeout(function () { els.phoneInput.focus({ preventScroll: true }); }, 320);
          }
        })
        .catch(function (error) {
          if (window.console) window.console.warn('[norsu popup]', error);
          setError('email', 'Something went wrong — please try again.');
        })
        .then(function () { setLoading(els.emailSubmit, false); });
    });
  }

  if (els.phoneForm) {
    els.phoneForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var phone = normaliseAuPhone(els.phoneInput.value || '');

      if (!phone) {
        setError('phone', 'Please enter a valid Australian mobile number.');
        els.phoneInput.focus();
        return;
      }
      setError('phone', '');
      setLoading(els.phoneSubmit, true);

      // The client endpoint takes phone_number but rejects an explicit
      // consent block, so SMS consent follows the list's own settings.
      subscribe({ email: state.email, phone_number: phone })
        .then(function () {
          track('norsu_popup_submit', { method: 'sms' });
        })
        .catch(function (error) {
          if (window.console) window.console.warn('[norsu popup]', error);
        })
        .then(function () {
          setLoading(els.phoneSubmit, false);
          goToStep('success');
        });
    });
  }

  root.querySelectorAll('[data-nsp-skip]').forEach(function (button) {
    button.addEventListener('click', function () { goToStep('success'); });
  });

  if (els.copyBtn) {
    els.copyBtn.addEventListener('click', function () {
      var code = els.copyBtn.getAttribute('data-nsp-copy');
      var label = els.copyBtn.textContent;
      var done = function () {
        els.copyBtn.textContent = 'Copied';
        window.setTimeout(function () { els.copyBtn.textContent = label; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { /* no-op */ });
      }
    });
  }

  /* ---- close wiring --------------------------------------- */
  if (els.close) els.close.addEventListener('click', function () { close('close'); });
  if (els.scrim) els.scrim.addEventListener('click', function () { close('scrim'); });

  root.querySelectorAll('[data-nsp-dismiss]').forEach(function (button) {
    button.addEventListener('click', function () { close('decline'); });
  });

  root.querySelectorAll('[data-nsp-done]').forEach(function (button) {
    button.addEventListener('click', function () { close('joined'); });
  });

  document.addEventListener('keydown', function (event) {
    if (!state.open) return;
    if (event.key === 'Escape') { close('esc'); return; }
    if (event.key !== 'Tab') return;

    var focusable = els.card.querySelectorAll(
      'a[href], button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])'
    );
    var visible = Array.prototype.filter.call(focusable, function (el) {
      return el.offsetParent !== null;
    });
    if (!visible.length) return;

    var first = visible[0];
    var last = visible[visible.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (teaser) {
    teaser.addEventListener('click', function () {
      teaser.setAttribute('data-show', 'false');
      open('teaser');
    });
  }

  /* ---- triggers ------------------------------------------- */
  // Pull the hero photo in only once we know the popup can actually appear.
  function preloadImage() {
    var img = root.querySelector('[data-nsp-img]');
    if (!img || img.getAttribute('src')) return;
    img.loading = 'eager';
    if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
    img.setAttribute('src', img.getAttribute('data-src') || '');
  }

  function arm() {
    if (state.armed) return;
    state.armed = true;
    preloadImage();

    var fired = false;

    // Returns false when it declined to open, so a blocked trigger can be
    // retried rather than silently spent.
    function fire(source) {
      if (fired || state.open) return true;
      if (otherOverlayOpen()) return false;
      fired = true;
      open(source);
      return true;
    }

    // 1. time on page — keep checking back while a drawer is in the way
    window.setTimeout(function attempt() {
      if (fired || state.open) return;
      if (!fire('delay')) window.setTimeout(attempt, 3000);
    }, (cfg.delaySeconds || 25) * 1000);

    // 2. scroll depth — whichever lands first
    var onScroll = function () {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = (window.pageYOffset / scrollable) * 100;
      if (pct < (cfg.scrollPercent || 50)) return;
      if (fire('scroll')) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // 3. desktop exit intent
    if (cfg.exitIntent && window.matchMedia('(min-width: 861px)').matches) {
      document.addEventListener('mouseout', function (event) {
        if (event.clientY <= 0 && !event.relatedTarget) fire('exit-intent');
      });
    }
  }

  if (shouldSkip()) {
    showTeaser();
  } else {
    arm();
  }

  // Manual hook: any element with data-norsu-signup opens it on demand,
  // e.g. a footer "Join the list" link.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-norsu-signup]');
    if (!trigger) return;
    event.preventDefault();
    open('manual');
  });
})();
